/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  ResultOfProposalDataLossViewModel,
  ResultOfProposalInformationViewModel,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    ResultOfProposalDataLossViewModelFromJSON,
    ResultOfProposalDataLossViewModelToJSON,
    ResultOfProposalInformationViewModelFromJSON,
    ResultOfProposalInformationViewModelToJSON,
} from '../models';

export interface ProposalsInfosGetEditProposalInformationRequest {
    proposalId: number;
}

export interface ProposalsInfosGetProposalDataLossRequest {
    proposalId: number;
    currentStep?: ProposalsInfosGetProposalDataLossCurrentStepEnum;
}

/**
 * 
 */
export class ProposalsInfosApi extends runtime.BaseAPI {

    /**
     * Get a proposal form base information
     */
    async proposalsInfosGetEditProposalInformationRaw(requestParameters: ProposalsInfosGetEditProposalInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfProposalInformationViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling proposalsInfosGetEditProposalInformation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposals/{proposalId}/information`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfProposalInformationViewModelFromJSON(jsonValue));
    }

    /**
     * Get a proposal form base information
     */
    async proposalsInfosGetEditProposalInformation(requestParameters: ProposalsInfosGetEditProposalInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfProposalInformationViewModel> {
        const response = await this.proposalsInfosGetEditProposalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the steps that will be affected by data loss if new information is saved
     */
    async proposalsInfosGetProposalDataLossRaw(requestParameters: ProposalsInfosGetProposalDataLossRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfProposalDataLossViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling proposalsInfosGetProposalDataLoss.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentStep !== undefined) {
            queryParameters['currentStep'] = requestParameters.currentStep;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposals/{proposalId}/dataloss`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfProposalDataLossViewModelFromJSON(jsonValue));
    }

    /**
     * Get the steps that will be affected by data loss if new information is saved
     */
    async proposalsInfosGetProposalDataLoss(requestParameters: ProposalsInfosGetProposalDataLossRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfProposalDataLossViewModel> {
        const response = await this.proposalsInfosGetProposalDataLossRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ProposalsInfosGetProposalDataLossCurrentStepEnum = {
    Step1: 'Step1',
    Step2: 'Step2',
    Step3: 'Step3',
    Step4: 'Step4',
    Step5: 'Step5',
    Step6: 'Step6',
    Step5PersonalDetails: 'Step5_PersonalDetails',
    Step5EmploymentAndTax: 'Step5_EmploymentAndTax',
    Step5SecondLifeDetails: 'Step5_SecondLifeDetails',
    Step5ThirdParties: 'Step5_ThirdParties',
    Step5PaymentMethods: 'Step5_PaymentMethods',
    Step5AppointIntermediary: 'Step5_AppointIntermediary',
    Step5TrustAndPolicyDetails: 'Step5_TrustAndPolicyDetails',
    Step5TaxDetails: 'Step5_TaxDetails',
    Step5RelatedParties: 'Step5_RelatedParties',
    Step3Scenarios: 'Step3_Scenarios',
    Step5JustPortfolio: 'Step5_JustPortfolio'
} as const;
export type ProposalsInfosGetProposalDataLossCurrentStepEnum = typeof ProposalsInfosGetProposalDataLossCurrentStepEnum[keyof typeof ProposalsInfosGetProposalDataLossCurrentStepEnum];
